import { apiSlice } from '../../../api/common/apiSlice';
import { ApiTagType } from '../../../constants/apiTagType';
import {
  CreatePlanRulesGroupRequest,
  FetchPlanRulesHistoryArgs,
  FetchPlanRulesHistoryResponse,
  PlanRulesView,
  PublishPlanRulesRequest,
} from '../../../types/planRules';

/** Premium tab (Settings → Premium), through madkhol-admin's `/admin/plan-rules` routes. */
export const planRulesApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    fetchPlanRules: builder.query<PlanRulesView, void>({
      query: () => ({ url: '/admin/plan-rules', method: 'GET' }),
      providesTags: [ApiTagType.PlanRules],
    }),
    publishPlanRules: builder.mutation<PlanRulesView, PublishPlanRulesRequest>({
      query: (body) => ({ url: '/admin/plan-rules/publish', method: 'POST', body }),
      invalidatesTags: [ApiTagType.PlanRules, ApiTagType.PlanRulesHistory],
    }),
    createPlanRulesGroup: builder.mutation<PlanRulesView, CreatePlanRulesGroupRequest>({
      query: (body) => ({ url: '/admin/plan-rules/groups', method: 'POST', body }),
      invalidatesTags: [ApiTagType.PlanRules, ApiTagType.PlanRulesHistory],
    }),
    fetchPlanRulesHistory: builder.query<FetchPlanRulesHistoryResponse, FetchPlanRulesHistoryArgs>({
      query: ({ tableName, page, limit }) => ({
        url: '/admin/plan-rules/history',
        method: 'GET',
        params: { ...(tableName ? { tableName } : {}), page, limit },
      }),
      providesTags: [ApiTagType.PlanRulesHistory],
    }),
  }),
});

export const {
  useFetchPlanRulesQuery,
  usePublishPlanRulesMutation,
  useCreatePlanRulesGroupMutation,
  useFetchPlanRulesHistoryQuery,
} = planRulesApiSlice;
